import { useState, useEffect } from "react";
import axios from "axios";
import reactStringReplace from "react-string-replace";
import { ReactComponent as SearchIcon } from "../../assets/search.svg";
import { ReactComponent as CloseIcon } from "../../assets/close.svg";
import { api } from "../../utils/api";

export default function KeywordSearch({ setSelectedNode }) {
	const [data, setData] = useState([]);
	const [searchTerm, setSearchTerm] = useState("");
	const [searchResults, setSearchResults] = useState([]);
	const [showSearch, setShowSearch] = useState(true);
	const [showResults, setShowResults] = useState(false);
	const [showClear, setShowClear] = useState(false);
	const [selectedResult, setSelectedResult] = useState(null);

	//Get all the data for local searching
	useEffect(() => {
		async function fetchData() {
			//TODO decide if we want to filter on the frontend
			const response = await axios.get(`${api.url}/${api.endpoint}/search/`);
			setData(response.data);
		}
		fetchData();
	}, []);

	//Search within the data
	useEffect(() => {
		const results =
			data && searchTerm
				? data.filter((researcher) =>
					researcher.name.toLowerCase().includes(searchTerm.toLowerCase())
				)
				: [];
		setShowResults(results.length > 0 ? true : false);
		setSearchResults(results);
	}, [searchTerm, data]);

	//Get the node for a selected result
	useEffect(() => {
		if (selectedResult) {
			async function fetchNode() {
				const response = await axios.get(
					`${api.url}/${api.endpoint}/search/${selectedResult}`
				);
				setSelectedNode(response.data);
			}
			fetchNode();
		} else {
			setSelectedNode(null);
		}
	}, [selectedResult, setSelectedNode]);

	const handleChange = (event) => {
		setSearchTerm(event.target.value);
	};

	const handleSubmit = (event) => {
		event.preventDefault();
		setShowResults(true);
		setShowSearch(false);
		setShowClear(true);
	};

	const handleClear = (event) => {
		event.preventDefault();
		setSearchTerm("");
		setShowResults(false);
		setShowSearch(true);
		setShowClear(false);
		setSelectedResult(null);
	};

	const handleClickResult = (event, item) => {
		event.preventDefault();
		setShowResults(false);
		setShowSearch(false);
		setShowClear(true);
		setSearchResults([]);
		setSearchTerm(item.name.split(" ").reverse().join(", "));
		setSelectedResult(item.id);
	};

	return (
		<div className="flex flex-col relative z-50">
			<form onSubmit={handleSubmit} className="flex flex-col relative">
				<label className="uppercase font-bold text-sm tracking-tight pb-2 -mt-4 pr-4 network-map-header--label">
					Search for Researcher
				</label>
				<input
					type="text"
					placeholder="Search by Researcher Name"
					value={searchTerm}
					onChange={handleChange}
					className="border-2 border-black py-2 px-4"
				/>
				{showSearch ? (
					<button
						type="submit"
						className="absolute top-4 bottom-0 right-0 w-10 bg-transparent flex items-center justify-center network-map-header--submit-clear"
					>
						<SearchIcon />
					</button>
				) : null}
				{showClear ? (
					<button
						onClick={handleClear}
						className="absolute top-4 bottom-0 right-0 w-10 bg-transparent flex items-center justify-center network-map-header--submit-clear"
					>
						<CloseIcon />
					</button>
				) : null}
			</form>
			{searchResults && showResults ? (
				<div className="absolute top-12 mt-1 right-0 left-0 border-solid border-2 border-black p-4 border-t-0 bg-white">
					{searchResults.map((item) => (
						<button
							key={item.id}
							className="text-base font-medium text-gray-900 block py-1 my-1"
							onClick={(e) => handleClickResult(e, item)}
						>
							{reactStringReplace(
								item.name.split(" ").reverse().join(", "),
								searchTerm,
								(match, i) => (
									<span key={i} className="font-bold">
										{match}
									</span>
								)
							)}
						</button>
					))}
				</div>
			) : null}
		</div>
	);
}
